import { LogOut, Menu } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { WhatsNewButton } from '../../whats-new';

interface HeaderProps {
    /** When provided (admin on a narrow viewport), shows a hamburger to open the nav drawer. */
    onMenuClick?: () => void;
}

export function Header({ onMenuClick }: HeaderProps) {
    const { user, logout } = useAuth();

    return (
        <header
            className="bg-white border-b border-gray-200 px-6 pb-3 flex items-center justify-between"
            // Keep the header content clear of the native status bar / notch in the
            // installed PWA (status-bar-style is black-translucent → content renders
            // under the status bar). env() is 0 in a normal browser, so this is a no-op there.
            style={{ paddingTop: 'calc(0.75rem + env(safe-area-inset-top))' }}
        >
            {user?.isAdmin ? (
                // Hamburger only below lg (the static sidebar covers lg+); empty otherwise.
                onMenuClick ? (
                    <button
                        onClick={onMenuClick}
                        className="lg:hidden -ml-2 p-2 rounded-lg text-gray-600 hover:bg-gray-100"
                        aria-label="Open navigation"
                    >
                        <Menu className="w-5 h-5" />
                    </button>
                ) : (
                    <div />
                )
            ) : (
                <div className="flex items-center gap-3">
                    <span className="text-lg font-bold text-gray-900">Reporting App</span>
                    <span className="text-sm text-gray-400">|</span>
                    <span className="text-sm text-gray-500">Dolder Group</span>
                </div>
            )}
            <div className="flex items-center gap-4">
                <WhatsNewButton />
                {!user?.isAdmin && user?.email && (
                    <span className="text-sm text-gray-500">{user.email}</span>
                )}
                <button
                    onClick={logout}
                    className="flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 transition-colors"
                >
                    <LogOut className="w-4 h-4" />
                    Logout
                </button>
            </div>
        </header>
    );
}
